<template>
  <!-- 项目开票申请 -->
  <div class="invoiceManagePage" v-if="!showLoad">
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        label="项目合同："
        :required="editType"
        readonly
        v-model="htData.contractName"
        @click="showProjectPicker"
        :is-link="editType"
        :placeholder="editType?'请选择':''"
        rows="1"
        autosize
        type="textarea"
        class="ggInput"
      />
      <van-field
        v-if="baseData.contractId"
        v-model="htData.mainClassName"
        readonly
        label="项目类型："
        class="ggInput moreText"
      />
      <van-field
        v-if="baseData.contractId"
        v-model="htData.contractAmount"
        readonly
        label="合同金额（元）："
        class="ggInput moreText"
      />
      <van-field
        v-if="baseData.contractId"
        v-model="htData.contractAmountTotal"
        readonly
        label="累计开票金额（元）："
        class="ggInput moreText"
      />
      <van-field
        v-if="baseData.contractId"
        v-model="htData.applyAmountTotal"
        readonly
        label="累计申请开票金额（元）："
        class="ggInput moreText"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary dwBox">
      <van-field
        v-model="baseData.amount"
        :required="editType"
        :readonly="!editType"
        type="number"
        clearable
        @input="amountChange"
        class="ggInput"
        input-align="right"
        label="开票金额（元）："
        :placeholder="editType ? '请输入...  ' : '' "
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="typeName"
        :required="editType"
        readonly
        clearable
        class="ggInput"
        input-align="right"
        label="发票类型："
        @click="getTypePicker"
        :is-link="editType"
        :placeholder="editType?'请选择':''"
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary">
      <van-field
        v-model="baseData.oppositeTallage"
        :required="editType"
        :readonly="!editType"
        clearable
        class="ggInput"
        input-align="right"
        label="对方税号："
        :placeholder="editType ? '请输入...  ' : '' "
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary dwBox">
      <van-field
        v-model="baseData.oppositeCompany"
        :required="editType"
        :readonly="!editType"
        clearable
        class="ggInput"
        input-align="right"
        label="对方单位名称："
        :placeholder="editType ? '请输入...  ' : '' "
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary beizhu">
      <van-field
        v-model="baseData.reason"
        rows="1"
        autosize
        input-align="right"
        :required="editType"
        label="开票原因："
        type="textarea"
        :placeholder="editType ? '请输入...  ' : '' "
        :readonly="!editType"
      />
    </van-cell-group>

    <!-- 操作按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode=='add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput('add')"
      >提交</van-button>
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode!='add'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="baseData.verifyStatus != 'pass' || baseData.verifyStatus != 'deny'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply('del')"
            >删除</van-button>
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput('edit')"
            >保存</van-button>
          </van-col>
        </van-row>
      </div>
    </template>
    <!-- 弹出框 -->
    <!-- 项目合同选择器 -->
    <van-popup v-model="showHtPicker" position="bottom" class="roleBox">
      <project-ht-view @setReview="setRetinue"></project-ht-view>
    </van-popup>
    <!-- 发票类型列表 -->
    <van-popup v-model="showTypePicker" position="bottom">
      <van-picker
        show-toolbar
        :columns="this.fpTypeList"
        value-key="dictName"
        @cancel="showTypePicker = false"
        @confirm="saveFpType"
      />
    </van-popup>
  </div>
</template>
<script>
/*eslint-disable*/
// import newApi from "lodash";
const projectHtView = () =>
  import("@/components/businessTripMould/projectHtView");

import { mapState, mapMutations } from "vuex";
import { getDeviceType, closePage,is_wei } from "@/common/getDeviceType/getDeviceType";
import { dateFormat, getDictList } from "@/utils/common";
export default {
  name: "invoiceManage",
  components: {
    projectHtView,
  },
  data() {
    return {
      commonId: "", //用户申请Id
      mode: "",
      editType: false,
      HtColumns: "", //合同列表
      showHtPicker: false, //合同弹框
      baseData: {
        amount: "", //申请开票金额
        applicantId: "", //申请人id
        baseAnnexes: null,
        contractId: "", //所属合同id
        oppositeCompany: "", //对方单位名称
        oppositeTallage: "", //对方税号
        reason: "", //开票原因
        type: "", //发票类型【码表】
        verifyStatus: "hold",
      },
      beforeAmount: "",
      typeName: "",
      htData: {
        //合同data信息
        contractName: "",
        mainClassName:"",
        contractAmount: "",
        applyAmountTotal: "",
        contractAmountTotal: "",
      },
      fpCode: "fapiao",
      showTypePicker: false, //发票类型弹框
      fpTypeList: [], //发票类型列表
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      clientType: getDeviceType(),
    };
  },
  mounted() {
     if(is_wei()){
      document.title="开票申请";
    }
    window.editPage = this.editPage; //编辑页面
    this.mode = this.$route.query.commonType;
    this.commonId = this.$route.query.commonId;
    this.$nextTick(() => {
      this.setShowLoad(false); //加载状态，默认为true加载
      if (this.userinfo && this.userinfo.id) {
        this.baseData.applicantId = this.userinfo.id;
        this.getFpList();
        if (this.mode != "add") {
          this.getDetail();
        } else {
          this.editType = true;
        }
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    editPage() {
      //app调用编辑
      this.editType = true;
    },
    showProjectPicker() {
      if (this.editType) {
        this.showHtPicker = true;
      }
    },
    getDetail() {
      let _this = this;
      _this.$api.finance.projectOpenTickets
        .invoiceDetail(this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.baseData = res.data;
            _this.getHtPrice(res.data.contractId);
            _this.beforeAmount = this.baseData.amount;
            _this.typeName = this.baseData.typeName;
            if (
              (_this.baseData.verifyStatus != "pass" && _this.mode == "edit") ||
              (_this.baseData.verifyStatus != "deny" && _this.mode == "edit")
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getFpList() {
      let _this = this;
      this.fpTypeList = await getDictList(this.fpCode);
    },
    setRetinue(data) {
      let _this = this;
      _this.showHtPicker = false;
      _this.baseData.contractId = data.id;
      _this.getHtPrice(_this.baseData.contractId);
    },
    getTypePicker() {
      //发票类型弹框
      if (this.editType) {
        this.showTypePicker = true;
      }
    },
    saveFpType(data) {
      this.showTypePicker = false;
      this.baseData.type = data.dictCode;
      this.typeName = data.dictName;
    },
    getHtPrice(id) {
      let _this = this;
      _this.$api.finance.projectOpenTickets
        .getAmountByContractCode({
          contractId: id,
        })
        .then((res) => {
          if (res.code == 1) {
            this.htData = res.data;
          } else {
            console.log(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //编辑开票金额联动累计开票金额
    amountChange() {
      if (this.mode == "edit") {
        this.htData.applyAmountTotal =
          Number(this.htData.applyAmountTotal) -
          Number(this.beforeAmount) +
          Number(this.baseData.amount);
        this.beforeAmount = this.baseData.amount;
      }
      if (
        parseInt(this.htData.contractAmount) -
          parseInt(this.htData.applyAmountTotal) -
          parseInt(this.baseData.amount) <
        0
      ) {
        this.$toast("累计开票金额不能大于合同金额");
        this.baseData.amount = "";
      }
    },
    //删除项目开票
    delApply() {
      let _this = this;
      let text = "删除";
      this.$dialog
        .confirm({
          title: "提示",
          message: "你确定" + text + "操作吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.finance.projectOpenTickets
            .deleteApplyOpenTickets(_this.baseData.id)
            .then((res) => {
              if (res.code == "1") {
                let text = "删除操作成功";
                closePage(text);
              } else {
                // console.log(res.msg);
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        })
        .catch(() => {
          // on cancel
        });
    },
    checkInput() {
      if (
        this.baseData.amount == "" ||
        this.baseData.applicantId == "" ||
        this.baseData.contractId == "" ||
        this.baseData.oppositeCompany == "" ||
        this.baseData.oppositeTallage == "" ||
        this.baseData.reason == "" ||
        this.baseData.type == ""
      ) {
        this.$toast("带星号为必填项，不能为空");
      } else {
        this.saveFpDetail();
      }
    },
    saveFpDetail() {
      let _this = this;
      _this.btnLoading = true;
      _this.$api.finance.projectOpenTickets
        .addEditApplyOpenTickets(_this.mode, _this.baseData)
        .then((res) => {
          if (res.code == "1") {
            let text = this.mode == "add" ? "添加成功" : "编辑成功";
            closePage(text);
          } else {
            // console.log(res.msg);
            _this.$toast(res.msg);
          }
          _this.btnLoading = false;
        })
        .catch((err) => {
          console.log(err);
          _this.btnLoading = false;
          _this.$toast("网络失败，请稍后重试");
        });
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
  },
  watch: {
    userinfo: {
      handler: function () {
        if (this.userinfo && this.userinfo.id) {
          this.baseData.applicantId = this.userinfo.id;
          this.getFpList();
          if (this.mode != "add") {
            this.getDetail();
          } else {
            this.editType = true;
          }
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.invoiceManagePage {
  width: 100%;
  height: 100%;
  background-color: #f6f6f6;
  overflow-y: scroll;
  padding-bottom: 80px;
  .roleBox {
    width: 100%;
    height: 100%;
    padding-top: 5px;
    // overflow-y: initial;
  }
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone {
    .moreText {
      .van-cell__title {
        width: 180px;
      }
    }
  }
  .baseNone.dwBox {
    .van-cell__title {
      width: 180px;
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }
  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
}
</style>